var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-col"},[_c('label',{staticClass:"font-medium text-black-800 dark:text-slate-50"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"ml-1 flex items-center mb-0.5"},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }